// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { SkeletalJointWire, SkeletalJointWireT } from '../mannequin/skeletal-joint-wire';


export class SkeletalPositionWire implements flatbuffers.IUnpackableObject<SkeletalPositionWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SkeletalPositionWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSkeletalPositionWire(bb:flatbuffers.ByteBuffer, obj?:SkeletalPositionWire):SkeletalPositionWire {
  return (obj || new SkeletalPositionWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSkeletalPositionWire(bb:flatbuffers.ByteBuffer, obj?:SkeletalPositionWire):SkeletalPositionWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SkeletalPositionWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

positionId():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

trackId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

joints(index: number, obj?:SkeletalJointWire):SkeletalJointWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new SkeletalJointWire()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 16, this.bb!) : null;
}

jointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startSkeletalPositionWire(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addPositionId(builder:flatbuffers.Builder, positionId:number) {
  builder.addFieldInt16(0, positionId, 0);
}

static addTrackId(builder:flatbuffers.Builder, trackId:number) {
  builder.addFieldInt32(1, trackId, 0);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt32(2, playerId, 0);
}

static addJoints(builder:flatbuffers.Builder, jointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, jointsOffset, 0);
}

static startJointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(16, numElems, 4);
}

static endSkeletalPositionWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSkeletalPositionWire(builder:flatbuffers.Builder, positionId:number, trackId:number, playerId:number, jointsOffset:flatbuffers.Offset):flatbuffers.Offset {
  SkeletalPositionWire.startSkeletalPositionWire(builder);
  SkeletalPositionWire.addPositionId(builder, positionId);
  SkeletalPositionWire.addTrackId(builder, trackId);
  SkeletalPositionWire.addPlayerId(builder, playerId);
  SkeletalPositionWire.addJoints(builder, jointsOffset);
  return SkeletalPositionWire.endSkeletalPositionWire(builder);
}

unpack(): SkeletalPositionWireT {
  return new SkeletalPositionWireT(
    this.positionId(),
    this.trackId(),
    this.playerId(),
    this.bb!.createObjList<SkeletalJointWire, SkeletalJointWireT>(this.joints.bind(this), this.jointsLength())
  );
}


unpackTo(_o: SkeletalPositionWireT): void {
  _o.positionId = this.positionId();
  _o.trackId = this.trackId();
  _o.playerId = this.playerId();
  _o.joints = this.bb!.createObjList<SkeletalJointWire, SkeletalJointWireT>(this.joints.bind(this), this.jointsLength());
}
}

export class SkeletalPositionWireT implements flatbuffers.IGeneratedObject {
constructor(
  public positionId: number = 0,
  public trackId: number = 0,
  public playerId: number = 0,
  public joints: (SkeletalJointWireT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const joints = builder.createStructOffsetList(this.joints, SkeletalPositionWire.startJointsVector);

  return SkeletalPositionWire.createSkeletalPositionWire(builder,
    this.positionId,
    this.trackId,
    this.playerId,
    joints
  );
}
}
